{{ meeting.date | date: 'd MMM y' }} •
{{ meeting.date | date: 'HH:mm' }}
@if (meeting.duration !== null) {
  • {{ meeting.duration | duration }}
}
@if (!meeting.isUpcoming && !meeting.isOngoing) {
  @let requestOptions = (retentionExtensionRequestOptions$ | async)?.data ?? null;
  @if (
    requestOptions !== null &&
    requestOptions.isEnabled &&
    meeting.retentionPeriodExpirationDate !== null &&
    (requestOptions.pendingRequest !== null || requestOptions.availableExtensionsInDays.length > 0)
  ) {
    @if (requestOptions.pendingRequest; as pendingRequest) {
      <span class="expiry-badge pending" [class.urgent]="isExpiryUrgent" [matTooltip]="getPendingRequestTooltip(pendingRequest)">
        {{ getExpiryText() }}
        <span class="separator">•</span>
        <mat-icon>hourglass_top</mat-icon>
        {{ 'MEETINGS.RETENTION_EXTENSION_REQUEST.PENDING_BADGE' | translate }}
      </span>
    } @else {
      <button
        type="button"
        class="expiry-badge requestable"
        [class.urgent]="isExpiryUrgent"
        [matTooltip]="getRequestableExpiryTooltip()"
        (click)="openRequestRetentionExtensionDialog(requestOptions)"
      >
        {{ getExpiryText() }}
        <mat-icon>more_time</mat-icon>
      </button>
    }
  } @else {
    <span class="expiry-badge" [class.urgent]="isExpiryUrgent" [matTooltip]="getExpiryTooltip()">
      {{ getExpiryText() }}
    </span>
  }
  @if (meeting.processingStatus === null) {
    <app-meeting-health-indicator [userActionsItems]="getMeetingHealthItems()" [avgConfidenceScore]="meeting.avgConfidenceScore"></app-meeting-health-indicator>
  }
}
@if (meeting.meetingSetIndex !== null && meeting.meetingSetSize !== null && meeting.meetingSetSize > 1) {
  <span class="part-badge" [matTooltip]="'MEETINGS.PART_BADGE_TOOLTIP' | translate: { index: meeting.meetingSetIndex + 1, total: meeting.meetingSetSize }">
    {{ 'MEETINGS.PART_BADGE_TEXT' | translate: { index: meeting.meetingSetIndex + 1, total: meeting.meetingSetSize } }}
  </span>
}
@if (meeting.processingStatus) {
  <span class="processing-progress">
    <span class="processing-progress-label">
      @if (isSplitting) {
        {{ 'MEETINGS.PROCESSING_STATUSES.SPLITTING_MEETING' | translate }}
      } @else if (isCheckingAgendaValidity) {
        {{ 'MEETINGS.PROCESSING_STATUSES.CHECKING_AGENDA_DOCUMENT' | translate }}
      } @else if (meeting.processingStatus === 'GENERATING_MINUTES' && meeting.minutesGenerationTemplateProgress; as tp) {
        {{ 'MEETINGS.PROCESSING_STATUSES.GENERATING_MINUTES_FOR_AGENDA_ITEM' | translate: { level: tp.level } }}
      } @else {
        {{ 'MEETINGS.PROCESSING_STATUSES.' + meeting.processingStatus | translate }}
      }
    </span>
    @if (meeting.processingProgress !== null && !isCheckingAgendaValidity) {
      <app-progress-loader [value]="meeting.processingProgress" loading></app-progress-loader>
      <span class="processing-progress-percentage">{{ meeting.processingProgress }}%</span>
    } @else {
      <app-progress-loader indeterminate></app-progress-loader>
    }
  </span>
}
